import React from "react";

const TermsOfServicePage = () => {
  return (
    <div className="bg-gray-50 dark:bg-gray-950 min-h-screen py-8 sm:py-16 px-4 sm:px-6 lg:px-8 font-sans">
      <div className="max-w-4xl mx-auto bg-white dark:bg-gray-900 shadow-xl rounded-2xl overflow-hidden border border-gray-100 dark:border-gray-700">
        {/* Premium Header Section */}
        <header className="bg-slate-900 dark:bg-slate-800 py-8 md:py-14 px-4 md:px-8 text-center text-white border-b dark:border-slate-700">
          <h1 className="text-3xl md:text-5xl font-extrabold tracking-tight uppercase border-b-4 border-white inline-block pb-2 mb-6">
            Terms of Service
          </h1>
          <div className="flex flex-col md:flex-row justify-center items-center gap-2 md:gap-4 text-slate-300 text-sm tracking-wide">
            <span className="font-bold text-white">
             Brightex Solutions Pvt Ltd
            </span>
            <span className="hidden md:inline">|</span>
            <span>Last Updated: January 2026</span>
          </div>
        </header>

        {/* Content Body */}
        <div className="p-5 sm:p-8 md:p-14 space-y-8 md:space-y-12 text-gray-700 dark:text-gray-300">
          {/* Section 1 */}
          <section className="group">
            <h3 className="text-xl font-bold text-slate-900 dark:text-white mb-4 border-l-4 border-slate-900 dark:border-slate-100 pl-4 transition-colors group-hover:border-blue-600">
              1. ACCEPTANCE OF TERMS
            </h3>
            <div className="space-y-4 leading-relaxed text-justify">
              <p>
                By accessing and using lapzop.com (the "Website"), you agree to
                be bound by these Terms of Service.
              </p>
              <p>
                The Website is owned and operated by Brightex Solutions Private
                Limited, a company registered at No. 5 and 6, Krishnappa
                Compound, Jaraganahally, JP Nagar 7th Phase, Kanakapura Main
                Road, Bengaluru, Karnataka, 560078. If you do not agree to these
                terms, please refrain from using the site.
              </p>
            </div>
          </section>

          {/* Section 2 */}
          <section>
            <h3 className="text-xl font-bold text-slate-900 dark:text-white mb-4 border-l-4 border-slate-900 dark:border-slate-100 pl-4">
              2. ELIGIBILITY AND ACCOUNT RESPONSIBILITY
            </h3>
            <div className="space-y-3">
              <p>
                <strong className="text-slate-900 dark:text-slate-200">User Age:</strong> By using
                this site, you represent that you are at least the age of
                majority in your state or province of residence.
              </p>
              <p>
                <strong className="text-slate-900 dark:text-slate-200">Account Security:</strong>{" "}
                Users are solely responsible for maintaining the confidentiality
                of their account credentials and passwords.
              </p>
              <p>
                <strong className="text-slate-900 dark:text-slate-200">
                  Accuracy of Information:
                </strong>{" "}
                You agree to provide current, complete, and accurate purchase
                and account information for all purchases made at our store.
              </p>
            </div>
          </section>

          {/* Section 3 */}
          <section className="bg-slate-50 dark:bg-gray-800 p-4 sm:p-6 rounded-xl border border-slate-100 dark:border-gray-700">
            <h3 className="text-xl font-bold text-slate-900 dark:text-white mb-4">
              3. PRODUCT CONDITION: "REFURBISHED" DISCLOSURE
            </h3>
            <div className="space-y-4">
              <p>
                <strong className="text-slate-900 dark:text-slate-200">Nature of Goods:</strong> You
                acknowledge and agree that the products sold on lapzop.com are
                "Refurbished."
              </p>
              <p>
                <strong className="text-slate-900 dark:text-slate-200">Functionality:</strong> While
                we guarantee that all products are fully functional, they may
                exhibit minor cosmetic imperfections (such as light scratches or
                dents) that do not impact the performance of the hardware.
              </p>
              <p>
                <strong className="text-slate-900 dark:text-slate-200">Standard Variations:</strong>{" "}
                Minor variations between the product images on the website and
                the actual product received may occur due to the unique nature
                of refurbished inventory.
              </p>
            </div>
          </section>

          {/* Section 4 */}
          <section>
            <h3 className="text-xl font-bold text-slate-900 dark:text-white mb-4 border-l-4 border-slate-900 dark:border-slate-100 pl-4">
              4. PRICING AND TAXATION
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="p-4 bg-white dark:bg-gray-800 border border-gray-100 dark:border-gray-700 rounded-lg shadow-sm">
                <span className="block text-xs font-bold text-slate-400 dark:text-slate-500 uppercase mb-1">
                  Currency
                </span>
                <p className="text-slate-800 dark:text-slate-200">
                  All prices are in Indian Rupees (INR).
                </p>
              </div>
              <div className="p-4 bg-white dark:bg-gray-800 border border-gray-100 dark:border-gray-700 rounded-lg shadow-sm">
                <span className="block text-xs font-bold text-slate-400 dark:text-slate-500 uppercase mb-1">
                  GST Compliance
                </span>
                <p className="text-slate-800 dark:text-slate-200">
                  Inclusive of applicable Goods and Services Tax (GST).
                </p>
              </div>
              <div className="p-4 bg-white dark:bg-gray-800 border border-gray-100 dark:border-gray-700 rounded-lg shadow-sm">
                <span className="block text-xs font-bold text-slate-400 dark:text-slate-500 uppercase mb-1">
                  GSTIN
                </span>
                <p className="text-slate-800 dark:text-slate-200 font-mono">29AAICB6992P1ZL</p>
              </div>
              <div className="p-4 bg-white dark:bg-gray-800 border border-gray-100 dark:border-gray-700 rounded-lg shadow-sm">
                <span className="block text-xs font-bold text-slate-400 dark:text-slate-500 uppercase mb-1">
                  Price Changes
                </span>
                <p className="text-slate-800 dark:text-slate-200">
                  Subject to modification without prior notice.
                </p>
              </div>
            </div>
          </section>

          {/* Section 5 */}
          <section>
            <h3 className="text-xl font-bold text-slate-900 dark:text-white mb-4 border-l-4 border-slate-900 dark:border-slate-100 pl-4">
              5. ORDER ACCEPTANCE AND CANCELLATION
            </h3>
            <div className="space-y-4">
              <p>
                <strong className="text-slate-900 dark:text-slate-200">Right to Refuse:</strong> We
                reserve the right to refuse or cancel any order for reasons
                including, but not limited to, product unavailability, errors in
                product or pricing information, or suspicion of fraudulent
                activity.
              </p>
              <p>
                <strong className="text-slate-900 dark:text-slate-200">
                  Payment Verification:
                </strong>{" "}
                Orders are only considered "Accepted" once payment has been
                verified and the shipping process has been initiated via our
                logistics partner (Shiprocket).
              </p>
            </div>
          </section>

          {/* Section 6 */}
          <section>
            <h3 className="text-xl font-bold text-slate-900 dark:text-white mb-4 border-l-4 border-slate-900 dark:border-slate-100 pl-4">
              6. SHIPPING AND DELIVERY
            </h3>
            <div className="space-y-3">
              <p>
                <strong className="text-slate-900 dark:text-slate-200">Logistics:</strong>{" "}
                Deliveries are managed through Shiprocket integration.
              </p>
              <p>
                <strong className="text-slate-900 dark:text-slate-200">Risk of Loss:</strong> The
                risk of loss and title for items purchased pass to you upon our
                delivery to the carrier.
              </p>
              <p className="bg-yellow-50 dark:bg-yellow-900/30 p-3 border-l-4 border-yellow-400 text-sm text-yellow-800 dark:text-yellow-200 uppercase font-bold tracking-tight">
                Damage Claims: Report within 24 hours of delivery with unboxing
                video.
              </p>
            </div>
          </section>

          {/* Section 7 & 8 */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-10">
            <section>
              <h3 className="text-lg font-bold text-slate-900 dark:text-white mb-3 uppercase tracking-tight">
                7. Limitation of Liability
              </h3>
              <p className="text-sm text-gray-500 dark:text-gray-400 leading-relaxed">
                Brightex Solutions Private Limited shall not be liable for any
                indirect, incidental, special, or consequential damages
                resulting from the use or inability to use our products.
              </p>
            </section>
            <section>
              <h3 className="text-lg font-bold text-slate-900 dark:text-white mb-3 uppercase tracking-tight">
                8. Intellectual Property
              </h3>
              <p className="text-sm text-gray-500 dark:text-gray-400 leading-relaxed">
                All content on lapzop.com is the property of Brightex Solutions
                Private Limited and protected by Indian and international
                copyright laws.
              </p>
            </section>
          </div>

          {/* Section 9 */}
          <section>
            <h3 className="text-xl font-bold text-slate-900 dark:text-white mb-4 border-l-4 border-slate-900 dark:border-slate-100 pl-4">
              9. GOVERNING LAW AND JURISDICTION
            </h3>
            <p className="leading-relaxed">
              These Terms of Service shall be governed by the laws of India. Any
              disputes shall be subject to the exclusive jurisdiction of the
              courts in{" "}
              <span className="font-semibold underline decoration-slate-300 dark:decoration-slate-600">
                Bengaluru, Karnataka
              </span>
              .
            </p>
          </section>

          {/* Section 10 - Contact */}
          <section className="mt-8 md:mt-12 p-5 sm:p-8 bg-slate-100 dark:bg-gray-800 rounded-2xl border border-slate-200 dark:border-gray-700">
            <h3 className="text-xl font-bold text-slate-900 dark:text-white mb-4 flex items-center gap-2">
              10. CONTACT INFORMATION
            </h3>
            <p className="mb-6 text-slate-600 dark:text-slate-300">
              For any questions regarding these Terms of Service, please
              contact:
            </p>
            <div className="space-y-4">
              <div>
                <p className="font-bold text-slate-900 dark:text-slate-200">
                 Brightex Solutions Pvt Ltd
                </p>
                <p className="text-sm text-slate-600 dark:text-slate-300 leading-relaxed max-w-md">
                  Address: No. 5 and 6, Krishnappa Compound, Jaraganahally, JP
                  Nagar 7th Phase, Kanakapura Main Road, Bengaluru, Karnataka,
                  560078
                </p>
              </div>
              <div className="pt-2 flex flex-wrap gap-3">
                <a
                  href="mailto:Jplapzop@gmail.com"
                  className="inline-block bg-slate-900 dark:bg-slate-700 text-white px-6 py-2 rounded-lg font-medium hover:bg-slate-800 dark:hover:bg-slate-600 transition-colors shadow-md"
                >
                  Jplapzop@gmail.com
                </a>
                <a
                  href="mailto:btxinwardoutward@gmail.com"
                  className="inline-block bg-slate-900 dark:bg-slate-700 text-white px-6 py-2 rounded-lg font-medium hover:bg-slate-800 dark:hover:bg-slate-600 transition-colors shadow-md"
                >
                  btxinwardoutward@gmail.com
                </a>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsOfServicePage;
